// @ts-ignore - import from .js file
import * as ActionTypes from "constants/ActionTypes"

const AT = ActionTypes as any;

const INIT_STATE = {
  loader: false,
  alertMessage: "",
  showMessage: false,
  initURL: "",
  authUser: null,
  processStatus: false,
  otpGenerate: "",
  activateUID: "",
  process: { status: false, action: "", message: "" },
  checkSessionResult: null,
  fromLogin: false,
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case AT.SIGNUP_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload,
      };
    }
    case AT.SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload,
        fromLogin: action.fromLogin ?? false,
      };
    }
    case AT.INIT_URL: {
      return {
        ...state,
        initURL: action.payload,
      };
    }
    case AT.SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        authUser: null,
        alertMessage: "",
        showMessage: false,
        initURL: "/",
        loader: false,
        fromLogin: false,
      };
    }
    case AT.RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        loader: false,
        processStatus: true,
      };
    }
    case AT.VERIFY_USER: {
      return {
        ...state,
        loader: true,
        processStatus: false,
        otpGenerate: "",
        activateUID: "",
      };
    }
    case AT.VERIFY_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        processStatus: true,
        otpGenerate: action.payload,
      };
    }
    case AT.VERIFY_OTP_SUCCESS: {
      return {
        ...state,
        loader: false,
        processStatus: true,
        activateUID: action.payload,
      };
    }

    case AT.SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false,
      };
    }
    case AT.HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: "",
        showMessage: false,
        loader: false,
      };
    }
    case AT.ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true,
      };
    }
    case AT.ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false,
      };
    }
    case AT.CHANGE_WORK_SHIFT_SUCCESS: {
      return {
        ...state,
        authUser: state.authUser ? { ...(state.authUser as any), current_shift: action.payload } : null,
      };
    }
    case AT.AUTH_PROCESS_SUCCESS: {
      return {
        ...state,
        process: action.payload,
      };
    }
    case AT.RESET_PROCESS_STATUS: {
      return {
        ...state,
        processStatus: false,
        process: { status: false, action: "", message: "" },
      };
    }

    case AT.REQUEST_RESET_USER_SUCCESS: {
      return {
        ...state,
        processStatus: true,
        process: {
          status: true,
          action: "requestResetUser",
          message: action.payload.res_msg,
        },
      };
    }

    // case REQUEST_RESET_USER_SUCCESS: {
    //   return {
    //     ...state,
    //     processStatus: true,
    //     process: {
    //       status: true,
    //       action: "requestResetUser",
    //       message:action.payload
    //     },
    //   };
    // }

    // case REQUEST_RESET_USER_SUCCESS: {
    //   return {
    //     ...state,
    //     processStatus: {
    //       status: true,
    //       action: "requestResetUser",
    //       message:action.payload
    //     },
    //   };
    // }

    // case REQUEST_RESET_USER_SUCCESS: {
    //   return {
    //     ...state,
    //     processStatus: {
    //       status: action.payload.status === 200,
    //       action: "requestResetUser",
    //       res_msg: action.payload.res_msg,
    //       res_code: action.payload.res_code,
    //       message: action.payload.message,
    //       // เก็บ response ทั้งหมดไว้ถ้าต้องการใช้
    //       complete_response: action.payload
    //     },
    //   };
    // }

    // case REQUEST_RESET_USER_CLEAR: {
    //   return {
    //     ...INIT_STATE,
    //     processStatus: {
    //       status: false,
    //       action: "requestResetUserClear",
    //       message: "",
    //     },
    //   };
    // }
    // case REQUEST_RESET_USER_INVALID: {
    //   return {
    //     ...state,
    //     processStatus: {
    //       status: false,
    //       action: "requestResetUserInvalid",
    //       message: "",
    //     },
    //   };
    // }

    case AT.REQUEST_RESET_USER_CLEAR: {
      return {
        ...INIT_STATE,
        processStatus: false,
        process: {
          status: false,
          action: "requestResetUserClear",
          message: '',
        },
      };
    }
    case AT.REQUEST_RESET_USER_INVALID: {
      return {
        ...state,
        processStatus: false,
        process: {
          status: false,
          action: "requestResetUserInvalid",
          message: "",
        },
      };
    }

    case AT.CHECK_SESSION_SUCCESS: {
      return {
        ...state,
        checkSessionResult: action.payload,
      };
    }
    case AT.UPDATE_USER_PERMISSION: {
      return {
        ...state,
        authUser: state.authUser ? { ...(state.authUser as any), user_permission: action.payload } : null,
      };
    }

    case AT.ACCEPT_POLICY_SUCCESS: {
      return {
        ...state,
        fromLogin: false,
        authUser: state.authUser ? { ...(state.authUser as any), policy_accepted: true } : state.authUser,
      };
    }

    default:
      return state;
  }
};
